import axios from "@/utils/request"

/**
 * loginApi => 首页登录
 * 
 * @param {Object} data 
 * @returns 
 */
export function loginApi(data) {
    return axios({
        url: "/api/Login",
        method: "POST",
        data: data
    })
}

/**
 * getUserApi => 根据token获取用户
 * 
 * @param {Object} data 
 * @returns 
 */
export function getUserApi(data) {
    return axios({
        url: "/api/GetUser",
        method: "GET",
        params: data
    })
}


/**
 * changeUserApi => 密码修改
 * 
 * @param {Object} data 
 * @returns 
 */
export function changeUserApi(data) {
    return axios({
        url: "/api/ChangeUser",
        method: "POST",
        data: data
    })
}

/**
 * getUserListApi => 获取用户列表
 * 
 * @param {Object} data 
 * @returns 
 */
export function getUserListApi(data) {
    return axios({
        url: "/api/GetUserList",
        method: "GET",
        params: data
    })
}

/**
 * selectuserinforApi => 搜索查询用户
 * 
 * @param {Object} data 
 * @returns 
 */
export function selectuserinforApi(data) {
    return axios({
        url: "/api/Selectuserinfor",
        method: "POST",
        data: data
    })
}

/**
 * updataUseroffApi => 是否开启用户登录
 * 
 * @param {Object} data 
 * @returns 
 */
export function updataUseroffApi(data) {
    return axios({
        url: "/api/UpdataUseroff",
        method: "POST",
        data: data
    })
}

/**
 * adduserinforApi => 添加用户列表
 * 
 * @param {Object} data 
 * @returns 
 */
export function adduserinforApi(data) {
    return axios({
        url: "/api/Adduserinfor",
        method: "POST",
        data: data
    })
}

/**
 * changeuserinforApi => 修改用户列表
 * 
 * @param {Object} data 
 * @returns 
 */
export function changeuserinforApi(data) {
    return axios({
        url: "/api/Changeuserinfor",
        method: "POST",
        data: data
    })
}

/**
 * delautUsersApi => 删除用户列表
 * 
 * @param {Object} data 
 * @returns 
 */
export function delautUsersApi(data) {
    return axios({
        url: "/api/DelautUsers",
        method: "POST",
        data: data
    })
}